module.exports = __webpack_public_path__ + "img/h-page4-40.2b6f185b.png";